class TokenService {
  setRefreshToken (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken)
  }

  getLocalRefreshToken () {
    const refreshToken = localStorage.getItem('refreshToken')
    if (refreshToken) {
      return refreshToken
    }
    return null
  }

  getLocalAccessToken () {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      return user.impersonateToken ? user.impersonateToken : user.access_token
    }
    return null
  }

  removeLocalAccessToken () {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      delete user.access_token
      localStorage.setItem('user', JSON.stringify(user))
    }
  }

  updateLocalAccessToken (token) {
    let user = JSON.parse(localStorage.getItem('user'))
    user.accessToken = token
    localStorage.setItem('user', JSON.stringify(user))
  }

  getUser () {
    return JSON.parse(localStorage.getItem('user'))
  }

  setUser (user) {
    localStorage.setItem('user', JSON.stringify(user))
    this.setRefreshToken(user.refresh_token)
  }

  removeUser () {
    localStorage.removeItem('user')
  }

  addImpersonate (token) {
    const user = this.getUser()
    if (user) {
      user.impersonateToken = token
      this.setUser(user)
    }
  }

  removeImpersonate () {
    const user = this.getUser()
    if (user) {
      delete user.impersonateToken
      this.setUser(user)
    }
  }

  getRememberMe () {
    return localStorage.getItem('rememberMe')
  }

  setRememberMe (rememberMe) {
    return localStorage.setItem('rememberMe', rememberMe)
  }

  getLastActivityTime () {
    return localStorage.getItem('lastActivityTime')
  }

  setLastActivityTime () {
    localStorage.setItem('lastActivityTime', Date.now())
  }
}

export default new TokenService()



// WEBPACK FOOTER //
// ./src/services/tokenService.js